import * as React from "react";
import {
  DeleteOutlined,
  EditOutlined,
  ExportOutlined,
  ImportOutlined,
  MoreOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, MenuProps, notification } from "antd";
import { observer } from "mobx-react-lite";
import { ModalDelete } from "src/components/ModalDelete";
import { onError } from "src/common/onError";
import { t } from "i18next";
import { mc2SummaryStore as store } from "../mc2SummaryStore";
import { Mc2EditorModal } from "../Mc2EditorModal";
import { Mc2CopyTo } from "./Mc2CopyTo";
import { Mc2CopyFrom } from "./Mc2CopyFrom";

export const Mc2SummaryActions: React.FC = observer(() => {
  const emptySelection = !store.tableStore?.selected.length;
  const menuProps: MenuProps = {
    items: [
      {
        key: "states",
        label: "Смена состояния",
        icon: <RetweetOutlined />,
        disabled: !!store.statesReason || store.buzy,
        title: store.statesReason,
        onClick: () => store.setMode("states"),
      },
      {
        key: "copyTo",
        label: "Копировать В",
        icon: <ExportOutlined />,
        disabled: emptySelection || store.buzy,
        title: emptySelection
          ? "Необходимо выбрать хотя бы одну строку"
          : undefined,
        onClick: () => store.copyTo(),
      },
      {
        key: "copyFrom",
        label: t("Copy from"),
        icon: <ImportOutlined />,
        onClick: () => store.copyFrom(),
      },
      {
        key: "edit",
        label: "Редактировать",
        icon: <EditOutlined />,
        disabled: !!store.editReason || store.buzy,
        onClick: () => store.startEdit(),
        title: store.editReason,
      },
      {
        key: "delete",
        label: "Удалить",
        icon: <DeleteOutlined />,
        danger: true,
        disabled: !store.canDelete,
        onClick: () => store.startDelete(),
        title: store.deleteReason,
      },
    ],
  };

  return (
    <>
      <Dropdown menu={menuProps} placement="bottomLeft">
        <Button icon={<MoreOutlined />} />
      </Dropdown>
      <Mc2EditorModal
        open={store.mode === "edit"}
        close={closeModal}
        title="Редактирование экземпляра МС"
        initialValues={store.rowForEdit}
        onSelect={(data) => store.finalEdit(data)}
        sizeLineAttrNameId={store.sizeLineAttrNameId}
      />
      <ModalDelete
        open={store.mode === "delete"}
        message="Удалить выделенные строки?"
        onCancel={closeModal}
        onOk={() => {
          store
            .finalDelete()
            .then(() =>
              notification.success({ message: "Выполнено удаление строк" }),
            )
            .catch(onError);
        }}
        waiting={store.buzy}
      />
      <Mc2CopyTo store={store.copyToStore} />
      <Mc2CopyFrom store={store.copyFromStore} />
    </>
  );
});

const closeModal = () => store.setMode(null);
